var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmployeeReport',{ref:"employeeReport",attrs:{"userSettingsKey":"EmployeeDailyReport","title":_vm.$t('EmployeeDailyReport'),"currentDate":_vm.mondayDate,"mondayDate":_vm.mondayDate,"showOnlyOneDay":true},on:{"IsDirtyChanged":function($event){return _vm.onIsDirtyChanged($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }